import * as React from 'react'
import * as rt from '../../config/routeType'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { changeMapStyle, changePopup } from '../../redux/slices/Map/map'
import { show as showDrawerRight } from '../../redux/slices/Drawer/drawerRight'
import { Popover, FormControlLabel, FormControl } from '@mui/material'
import { RadioGroup, Radio } from '@mui/material'

const RowRadioButtonsGroup = ({ id, open, anchorEl, onClose }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  let location = useLocation()
  const { treeId } = useParams()
  const _styleMaps = useSelector(state => state.mapState.style)

  const anchorO = {
    vertical: 'top',
    horizontal: 'right',
  }
  const transformO = {
    vertical: 'top',
    horizontal: 'left',
  }

  const handleChangeMap = event => {
    dispatch(changeMapStyle(event.target.value))
    dispatch(changePopup(false))
    if (location.pathname === `/${rt.MANAGEMENT_TREE}/${rt.TREE}/${treeId}`)
      navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: true })
    if (location.pathname === `${rt.MAIN}${rt.TREE}`) dispatch(showDrawerRight(false))
  }

  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={{ top: 55, left: 55 }}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorO}
      transformOrigin={transformO}
      sx={{ width: 200 }}>
      <FormControl>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={_styleMaps.current}
          onChange={handleChangeMap}>
          {Object.keys(_styleMaps.type).map(key => {
            const _map = _styleMaps.type[`${key}`]
            return (
              <FormControlLabel
                key={`radio-${key}`}
                value={_map.id}
                control={<Radio />}
                label={_map.label}
                sx={{ ml: 0 }}
              />
            )
          })}
        </RadioGroup>
      </FormControl>
    </Popover>
  )
}
export default RowRadioButtonsGroup
